/**
 * The words of the portal's card "Recomandările tale" (validated by FPED on
 * 13.10.2026). Each sentence comes back as parts — `[text, bold]` — so the
 * card can set the numbers and the benefit in bold without building markup
 * out of text the team typed. The server (`services/referrals/referrer.py`)
 * decides what the card shows; nothing here decides.
 */

/** "un coleg", "3 colegi", "20 de colegi". */
function colleagues(n) {
  if (n === 1) return "un coleg";
  const tail = n % 100;
  return `${n}${n === 0 || tail === 0 || tail >= 20 ? " de" : ""} colegi`;
}

/** "Dacă 2 colegi se înscriu la curs cu acest cod și își plătesc locul, primești …." */
export function offerParts(required, benefit) {
  const n = Math.max(Number(required) || 1, 1);
  const verb = n === 1
    ? " se înscrie la curs cu acest cod și își plătește locul, primești "
    : " se înscriu la curs cu acest cod și își plătesc locul, primești ";
  return [["Dacă ", false], [colleagues(n), true], [verb, false], [benefit || "", true], [".", false]];
}

/** "1 din 2 recomandări plătite". */
export function progressParts(paid, required) {
  return [[`${Number(paid) || 0} din ${Math.max(Number(required) || 1, 1)}`, true], [" recomandări plătite", false]];
}

/** The colleagues who enrolled and have not paid: only how many (13.10.2026). */
export function unpaidLine(count) {
  const n = Number(count) || 0;
  if (!n) return "";
  if (n === 1) return "Un coleg s-a înscris cu codul tău și nu și-a plătit încă locul.";
  return `${colleagues(n)} s-au înscris cu codul tău și nu și-au plătit încă locul.`;
}

export const NOBODY_YET = "Încă nu s-a înscris nimeni cu codul tău.";

/** The last line of the card, by the state of the code. */
export function stateParts(card) {
  const benefit = card?.benefit || "";
  switch (card?.status) {
    case "eligible":
      return [["Ai strâns recomandările. Urmează să primești ", false], [benefit, true], ["; te contactăm noi.", false]];
    case "delivered":
      return [["Ai primit ", false], [benefit, true], [". Îți mulțumim că ai recomandat cursul!", false]];
    case "expired":
      return [[`Codul nu mai poate fi folosit din ${card?.expired_from || card?.until || ""}.`, false]];
    default:
      return [["Codul poate fi folosit până la ", false], [card?.until || "", true], [".", false]];
  }
}
